import { ApplicationError } from './application-error.model';

export const UNKNOWN_SERVICE_ERROR_CODE = 999;
export const NETWORK_SERVICE_ERROR_CODE = -1;
export const UNREACHABLE_SERVICE_ERROR_CODE = 0;
export const TOO_MANY_RETRIES_SERVICE_ERROR_CODE = 429;
export const INTERNAL_SERVICE_ERROR_CODE = 500;
export const DATA_SERVICE_ERROR_CODE = 998;
export const BAD_REQUEST_ERROR_CODE = 400;
export const FORBIDDEN_ERROR_CODE = 403;
export const NOT_FOUND_ERROR_CODE = 404;
export const VALIDATION_ERROR_CODE = 422;
export const PAYMENT_ERROR_CODE = 423;
export const NOT_AUTHORIZED_CODE = 401;
export const CONFLICT_ERROR_CODE = 409; 

export class ServiceError extends ApplicationError {
  private _details;
  constructor(code: number, message: string, details?: any) {
    super(code, message);
    this._details = details;
  }
  get details(): any {
    return this._details;
  }
}

export class UnknownServiceError extends ServiceError {
  constructor(details?: any) {
    super(UNKNOWN_SERVICE_ERROR_CODE, 'Unknown Error', details);
  }
}
export class NetworkServiceError extends ServiceError {
  constructor() {
    super(NETWORK_SERVICE_ERROR_CODE, 'Call Timed Out or was Aborted');
  }
}
export class UnreachableServiceError extends ServiceError {
  constructor() {
    super(UNREACHABLE_SERVICE_ERROR_CODE, 'Unreachable Service');
  }
}
export class DataServiceError extends ServiceError {
  constructor() {
    super(DATA_SERVICE_ERROR_CODE, 'Wrong data from service');
  }
}
export class BadRequestError extends ServiceError {
  constructor() {
    super(BAD_REQUEST_ERROR_CODE, 'Bad Request');
  }
}
export class NotFoundError extends ServiceError {
  constructor() {
    super(NOT_FOUND_ERROR_CODE, 'Not Found');
  }
}
export class ForbiddenError extends ServiceError {
  constructor(details?: any) {
    super(FORBIDDEN_ERROR_CODE, 'Forbidden', details);
  }
}
export class ValidationError extends ServiceError {
  constructor(details?: any) {
    super(VALIDATION_ERROR_CODE, 'Validation Error', details);
  }
}
export class NotAuthorized extends ServiceError {
  constructor(details?: any) {
    super(NOT_AUTHORIZED_CODE, 'Unauthorized', details);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/errors/service-error.model.ts